import type { SVGProps } from 'react';

export const DesktopIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12.9995 18.6665H18.9995C21.0222 18.6665 22.6662 17.0225 22.6662 14.9998V6.33319C22.6662 4.31053 21.0222 2.66653 18.9995 2.66653H4.99956C2.9769 2.66653 1.3329 4.31053 1.3329 6.33319V14.9998C1.3329 17.0225 2.9769 18.6665 4.99956 18.6665H10.9995V20.0412C9.76888 20.1212 8.54754 20.3412 7.36488 20.7132C6.83822 20.8798 6.54622 21.4398 6.71288 21.9678C6.87822 22.4932 7.43421 22.7838 7.96621 22.6212C10.5769 21.7985 13.4155 21.7972 16.0315 22.6212C16.1315 22.6518 16.2329 22.6678 16.3329 22.6678C16.7582 22.6678 17.1515 22.3945 17.2875 21.9678C17.4529 21.4412 17.1595 20.8798 16.6342 20.7145V20.7132C15.4515 20.3412 14.2302 20.1198 12.9995 20.0412V18.6665ZM12.0009 16.6665H18.9995C19.9182 16.6665 20.6662 15.9185 20.6662 14.9998V6.33319C20.6662 5.41453 19.9182 4.66653 18.9995 4.66653H4.99956C4.08089 4.66653 3.3329 5.41453 3.3329 6.33319V14.9998C3.3329 15.9185 4.08089 16.6665 4.99956 16.6665H11.9981C11.9986 16.6665 11.9991 16.6665 11.9995 16.6665C12 16.6665 12.0005 16.6665 12.0009 16.6665Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
